import React from 'react';

const TitleHero = ({title, imgsrc}) => {
    return (
        <>
            <div className='title-hero' style={{ height: "60vh", overflow: 'hidden' }}

            >
                <img src={imgsrc || "https://images.pexels.com/photos/6603941/pexels-photo-6603941.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"} alt="" className='w-100' style={{ objectFit: "cover", overflow: "hidden" }} />
                <div className="container">
                    <div className="row position-absolute py-5" style={{ top: '80px' }}>
                        <div className="col col-12" style={{ backgroundColor: "" }}>

                            <h1 className=' mb-4 title-hero-title'
                            >
                                {title || 'NEWSROOM'}
                            </h1>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TitleHero